
import { DefaultState, Filters } from 'store/types';

export const LODGING_OPTION_EXPORT_EXCEL_REQUEST = 'LODGING_OPTION_EXPORT_EXCEL_REQUEST';
export const LODGING_OPTION_EXPORT_EXCEL_SUCCESS = 'LODGING_OPTION_EXPORT_EXCEL_SUCCESS';
export const LODGING_OPTION_EXPORT_EXCEL_FAILURE = 'LODGING_OPTION_EXPORT_EXCEL_FAILURE';

export type LodgingOptionExportExcelState = DefaultState & {
  contents?: {};
};

export interface LodgingOptionExportExcelParams {
  filters: Filters;
  rowsCount: number;
};

interface LodgingOptionExportExcelRequest {
  type: typeof LODGING_OPTION_EXPORT_EXCEL_REQUEST;
};

interface LodgingOptionExportExcelSuccess {
  type: typeof LODGING_OPTION_EXPORT_EXCEL_SUCCESS,
  contents: {};
}

interface LodgingOptionExportExcelFailure {
  type: typeof LODGING_OPTION_EXPORT_EXCEL_FAILURE;
}

export type LodgingOptionExportExcelActionTypes = LodgingOptionExportExcelRequest | LodgingOptionExportExcelSuccess | LodgingOptionExportExcelFailure;